import { createFeatureSelector, createSelector } from '@ngrx/store';
import { cloneDeep } from 'lodash';
import { SpotlightProfile } from '../../../../core/models/spotlight-profiles.model';
import { spotlightProfilesFeatureKey, SpotlightProfilesState } from './spotlight-profiles.reducer';

export const selectSpotlightProfilesState = createFeatureSelector<SpotlightProfilesState>(
  spotlightProfilesFeatureKey,
);

export const selectSpotlightProfilesStateAction = createSelector(
  selectSpotlightProfilesState,
  (state) => state.action,
);

export const selectSpotlightProfilesPageData = createSelector(
  selectSpotlightProfilesState,
  (state) => {
    // We have to filter the skills to remove invalid values as sometimes the BE returns an array with null values
    const spotlightProfilesPageData = cloneDeep(state.spotlightProfilesPageData);
    spotlightProfilesPageData.profiles = spotlightProfilesPageData.profiles.map((profile) => {
      const output = <SpotlightProfile>{ ...profile };
      if (profile.skills) {
        output.skills = profile.skills?.filter((skills) => skills);
      }
      return output;
    });
    return spotlightProfilesPageData;
  },
);

export const selectSpotlightProfilesFilters = createSelector(
  selectSpotlightProfilesState,
  (state) => state.filters,
);

export const selectSpotlightProfilesFiltersSkills = createSelector(
  selectSpotlightProfilesFilters,
  (filters) => filters?.skills.map((skill) => ({ name: skill, id: skill })),
);

export const selectSpotlightProfilesFiltersSkillCategories = createSelector(
  selectSpotlightProfilesFilters,
  (filters) => filters?.skill_category_ids.map(Number),
);

export const selectSpotlightProfilesFiltersGroups = createSelector(
  selectSpotlightProfilesFilters,
  (filters) => filters?.groups,
);

export const selectSpotlightProfilesFiltersOrganizations = createSelector(
  selectSpotlightProfilesFilters,
  (filters) => filters?.organizations,
);
